import { render } from "./profilerModal.vue?vue&type=template&id=7512f6ec&ts=true"
import script from "./profilerModal.ts?vue&type=script&lang=ts"
export * from "./profilerModal.ts?vue&type=script&lang=ts"

import "./profilerModal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__